import styled from "styled-components";
import { QRCodeSVG } from "qrcode.react";

type QRCodeProps =
  | {
      src: string;
      value?: never;
      size?: number;
    }
  | {
      value: string;
      src?: never;
      size?: number;
    };

const DEFAULT_QR_CODE_SIZE = 56;

const QRCode = (props: QRCodeProps) => {
  const size = props.size ?? DEFAULT_QR_CODE_SIZE;

  return (
    <div className="flex items-center justify-center">
      {props.value !== undefined ? (
        <QRCodeSVG value={props.value} size={size} />
      ) : (
        <QRCodeImage src={props.src} $size={size} />
      )}
    </div>
  );
};

export default QRCode;

const QRCodeImage = styled.div<{ src: string; $size: number }>`
  background: center no-repeat ${(props) => `url(${props.src})`};
  /* height: min(40vw, 160px); */
  /* width: min(40vw, 160px); */
  height: ${(props) => props.$size}px;
  width: ${(props) => props.$size}px;
  background-size: 140%;
`;
